import { Pipe, PipeTransform } from '@angular/core';
import { displayTaskStatus } from 'app/core/options/task-status.opts';

@Pipe({ name: 'taskStatus' })
export class TaskStatusPipe implements PipeTransform {
  transform = displayTaskStatus
}
